import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { AnimatePresence, motion } from "motion/react";
import i18next from "i18next";
import { Icon } from "@/assets/icon/Icon";

export enum LanguageKind {
  EN = "en",
  CN = "zh-CN",
  TW = "zh-TW",
  JP = "ja",
  KO = "ko",
}

const LanguageOptions = [
  { label: "简体中文", value: LanguageKind.CN },
  { label: "繁體中文", value: LanguageKind.TW },
  { label: "日本語", value: LanguageKind.JP },
  { label: "한국어", value: LanguageKind.KO },
  { label: "English", value: LanguageKind.EN },
];

export const getDefaultLang = () => {
  if (i18next.language.includes("zh")) {
    return i18next.language as LanguageKind;
  }
  const lang = i18next.language.split("-")[0] as LanguageKind;
  if (Object.values(LanguageKind).includes(lang)) {
    return lang;
  }
  return LanguageKind.EN;
};

export const ChooseLanguage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [language, setLanguage] = useState<LanguageKind>(getDefaultLang());

  const onClick = async (lang: LanguageKind) => {
    setLanguage(lang);
    await i18next.changeLanguage(lang);
    setIsOpen(false);
  };

  console.info("state - language", i18next.language);
  console.info("i18next - language", language);
  console.info("browers - language", navigator.language);
  console.info("browers - languages", navigator.languages);

  return (
    <div className="fixed left-0 top-0 z-40 w-full">
      <div
        className="border-color-fill active:bg-color-fill-2 relative z-20 flex h-11 w-full items-center justify-between border-b bg-white px-6"
        onClick={() => {
          setIsOpen((prev) => !prev);
        }}
      >
        <div className="flex items-center gap-3">
          <Icon type="language" className="" />
          <div className="text-base">Language</div>
        </div>
        <div>
          <Icon
            type="selectLang"
            className={twMerge(
              "size-5 transition-transform ease-out",
              isOpen ? "rotate-180" : "rotate-0",
            )}
          />
        </div>
      </div>
      <AnimatePresence>
        {isOpen ? (
          <>
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="absolute top-11 z-20 w-full rounded-b-lg bg-white py-3 shadow-md"
            >
              {LanguageOptions.map((item) => (
                <div
                  key={item.value}
                  onClick={() => onClick(item.value)}
                  className="active:bg-color-fill-2 flex h-10 items-center justify-between px-6"
                >
                  <div>{item.label}</div>
                  <div
                    className={twMerge(
                      "flex items-center justify-center size-4 rounded-full border ",
                      item.value === language
                        ? "border-color-primary bg-color-primary"
                        : "border-color-border-2",
                    )}
                  >
                    {language === item.value ? (
                      <Icon type="check" className="size-2" />
                    ) : null}
                  </div>
                </div>
              ))}
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsOpen(false)}
              className="fixed inset-0 z-10 bg-[rgba(0,0,0,0.45)]"
            />
          </>
        ) : null}
      </AnimatePresence>
    </div>
  );
};
